export class   RequestTicketCounts {
    public OpenCount:number;
    public CloseCount:number;
    public RejectedCount :number;
}